module.exports = __webpack_public_path__ + "img/block-yellow.5b5dde15.png";